/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategyExecutionCustomFieldLink = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The StrategyExecutionCustomFieldLink model module.
   * @module model/StrategyExecutionCustomFieldLink
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategyExecutionCustomFieldLink</code>.
   * @alias module:model/StrategyExecutionCustomFieldLink
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>StrategyExecutionCustomFieldLink</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategyExecutionCustomFieldLink} obj Optional instance to populate.
   * @return {module:model/StrategyExecutionCustomFieldLink} The populated <code>StrategyExecutionCustomFieldLink</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('GoalMilestoneID')) {
        obj['GoalMilestoneID'] = ApiClient.convertToType(data['GoalMilestoneID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategicProgramID')) {
        obj['StrategicProgramID'] = ApiClient.convertToType(data['StrategicProgramID'], 'Integer');
      }
      if (data.hasOwnProperty('CustomFieldID')) {
        obj['CustomFieldID'] = ApiClient.convertToType(data['CustomFieldID'], 'Integer');
      }
      if (data.hasOwnProperty('CustomFieldOptionID')) {
        obj['CustomFieldOptionID'] = ApiClient.convertToType(data['CustomFieldOptionID'], 'Integer');
      }
      if (data.hasOwnProperty('CustomFieldTextValue')) {
        obj['CustomFieldTextValue'] = ApiClient.convertToType(data['CustomFieldTextValue'], 'String');
      }
      if (data.hasOwnProperty('CustomFieldDateValue')) {
        obj['CustomFieldDateValue'] = ApiClient.convertToType(data['CustomFieldDateValue'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} GoalMilestoneID
   */
  exports.prototype['GoalMilestoneID'] = undefined;
  /**
   * @member {Integer} StrategicProgramID
   */
  exports.prototype['StrategicProgramID'] = undefined;
  /**
   * @member {Integer} CustomFieldID
   * @default 0
   */
  exports.prototype['CustomFieldID'] = 0;
  /**
   * @member {Integer} CustomFieldOptionID
   */
  exports.prototype['CustomFieldOptionID'] = undefined;
  /**
   * @member {String} CustomFieldTextValue
   * @default ''
   */
  exports.prototype['CustomFieldTextValue'] = '';
  /**
   * @member {Date} CustomFieldDateValue
   */
  exports.prototype['CustomFieldDateValue'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


